import React, { Component } from 'react';
import { Modal, Table } from 'antd';
import { currency } from '../../quotationProduct/formatNumber';
export default class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  columns = [
    {
      title: '费用项',
      dataIndex: 'cost_name',
      width: 200
    },
    {
      title: '费用金额',
      dataIndex: 'cost_amount',
      width: 200,
      render: (text, record) => {
        const { tax_inclusive_real_price } = this.props;
        let total = 0;
        if (record.cost_mode === 1) {
          total += +(record.cost_amount);
        } else {
          total += +(record.cost_amount) * tax_inclusive_real_price * 0.01;
        }
        return <span>{currency(total)}</span>;
      }
    },
    {
      title: '费用备注',
      dataIndex: 'cost_explain',
      width: 600,
    },
  ];
  handleCancel = () => {
    this.props.modalCancel();
  }
  render() {
    const { costInfo } = this.props;
    return (
      <Modal
        title='费用明细'
        footer={null}
        open={true}
        onCancel={this.handleCancel}
      >
        <Table rowKey={(record) => record?.id} columns={this.columns} dataSource={costInfo} pagination={false} />
      </Modal>
    );
  }
}
